export default __webpack_public_path__ + "static/media/arrow_back_ios_new-24px.54051b60.svg";